export const SSO_LOGIN_METHODS = {
  azure: 'azure',
  google: 'google',
  okta: 'okta',
} as const;
